import { render, staticRenderFns } from "./PolizasSGMovimientos.vue?vue&type=template&id=4fad5a48&"
import script from "./PolizasSGMovimientos.vue?vue&type=script&lang=js&"
export * from "./PolizasSGMovimientos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports